"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Eshop;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Eshop(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "eshop"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.787,55.159,92.354,26.27a5.833,5.833,0,0,0-5.689-7.126H34.152l-.864-4.226a5.853,5.853,0,0,0-5.715-4.663H13.333A5.839,5.839,0,0,0,7.5,16.088V18.31a5.84,5.84,0,0,0,5.833,5.834h7.639l9.067,47.471a10.267,10.267,0,1,0,16.446,4.8H66.848A10.281,10.281,0,1,0,82.89,71.291l.372-1.642a5.832,5.832,0,0,0-5.688-7.126H42.521L42.192,59.7H80.1A5.8,5.8,0,0,0,85.787,55.159ZM36.9,57.488l.91,7.824a2.5,2.5,0,0,0,2.483,2.211h37.28a.832.832,0,0,1,.813,1.018l-.766,3.372a2.5,2.5,0,0,0,1.346,2.8,5.281,5.281,0,1,1-5.991.981,2.5,2.5,0,0,0-1.75-4.285H42.107a2.5,2.5,0,0,0-1.75,4.285,5.277,5.277,0,1,1-8.968,3.77,5.3,5.3,0,0,1,2.653-4.578,2.5,2.5,0,0,0,1.21-2.636L25.5,21.174a2.5,2.5,0,0,0-2.456-2.03H13.333a.835.835,0,0,1-.833-.834V16.088a.834.834,0,0,1,.833-.833h14.24a.837.837,0,0,1,.817.666l1.273,6.224a2.5,2.5,0,0,0,2.449,2H86.665a.835.835,0,0,1,.814,1.018L80.912,54.05h0a.828.828,0,0,1-.812.648H39.385A2.5,2.5,0,0,0,36.9,57.488Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.3,52.928a1.5,1.5,0,0,0,1.186-1.759l-4.435-22.81a1.5,1.5,0,0,0-2.946.573l4.436,22.81A1.5,1.5,0,0,0,38.3,52.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.4,52.956l.081,0A1.5,1.5,0,0,0,51.9,51.375l-1.227-22.81a1.484,1.484,0,0,0-1.578-1.418,1.5,1.5,0,0,0-1.418,1.579L48.9,51.536A1.5,1.5,0,0,0,50.4,52.956Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.649,52.95q.066.006.132.006a1.5,1.5,0,0,0,1.492-1.371l1.983-22.81a1.5,1.5,0,1,0-2.988-.259l-1.983,22.81A1.5,1.5,0,0,0,62.649,52.95Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74.829,52.918a1.476,1.476,0,0,0,.334.038,1.5,1.5,0,0,0,1.462-1.167l5.191-22.81a1.5,1.5,0,1,0-2.925-.666L73.7,51.123A1.5,1.5,0,0,0,74.829,52.918Z"
  })))));
}